// eslint-disable-next-line @typescript-eslint/no-explicit-any
export interface IFetchResponse<T = any> {
    data: T;
    headers: Headers;
    status: number;
}

export enum MaintenanceMode {
    FULL = 'full',
    READ_ONLY = 'read-only',
}

export interface MaintenanceInfo {
    mode?: MaintenanceMode;
    dateUntil?: string;
    dateFrom?: string;
}

export enum FetchContext {
    UNKNOWN,
    GUEST,
    USER,
    SUBSCRIBER,
}

export interface IFetchParams extends RequestInit {
    context?: FetchContext;
    params?: object;
    redirectNotFoundStatus?: number[];
}
